import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

export const enrichListingFromUrl = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((data: { url: string }) => {
    const url = String(data?.url ?? "").trim();
    if (!url) throw new Error("A website URL is required.");
    return { url };
  })
  .handler(async ({ data }) => {
    const { enrichFromUrl } = await import("./enrich.server");
    return enrichFromUrl(data.url);
  });
